import Header from "../components/header";

import { useSelector } from 'react-redux'
import HeaderSection from "../components/header-section";
import FilterBox from "../components/prenotationfilterBox";
import PrenotationTable from "../components/prenotationTable";

import React from "react";

const Prenotations = () => {
  const { namePharmacy } = useSelector((state: any) => state.login);
  const { user } = useSelector((state: any) => state.login);

  return (
    <>
      <Header titleLogOut={user?.name} />

      <HeaderSection visibleButton={true} titleSection={namePharmacy} />
      <FilterBox />
      <PrenotationTable />
    </>
  );
}

export default Prenotations;
